import { render, staticRenderFns } from "./Discussions.vue?vue&type=template&id=58ff98bd"
import script from "./Discussions.vue?vue&type=script&lang=js"
export * from "./Discussions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports